import {NgModule} from '@angular/core';
import {SafePipe} from './safe/safe.pipe';
import {SafeHtmlPipe} from './safe-html/safe-html.pipe';
import {LinebreakPipe} from './linebreak.pipe';

@NgModule({
    declarations: [
        SafePipe,
        SafeHtmlPipe,
        LinebreakPipe
    ],
    imports: [],
    exports: [
        SafePipe,
        SafeHtmlPipe,
        LinebreakPipe
    ]
})
export class PipesModule {}
